/** @jsxImportSource @emotion/react */
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { getImageThumbnailId } from '@sportninja/common/reducers/helpers'
import Text from '../../../ts-components/Text'
import {
  entityContainerStyle,
  entityBadgeStyle,
  entityImageStyle,
} from './styles'

interface EntityDisplayProps {
  entity: any
  entityType: string
}

/**
 * Entity Display component - displays entity information in a non-clickable format
 */
const EntityDisplay: React.FC<EntityDisplayProps> = ({
  entity,
  entityType,
}) => {
  'use memo'

  const getPlaceholderImage = () => {
    switch (entityType) {
      case 'organization':
        return '/images/generic_placeholders/placeholder_organization.png'
      case 'team':
        return '/images/generic_placeholders/placeholder_team.png'
      case 'schedule':
        return '/images/generic_placeholders/placeholder_competition.png'
      default:
        return '/images/generic_placeholders/placeholder_organization.png'
    }
  }

  return (
    <div css={entityContainerStyle}>
      <div css={entityBadgeStyle}>
        <img
          src={getImageThumbnailId(entity) || getPlaceholderImage()}
          alt={entity?.name || entity?.name_full}
          width={16}
          height={16}
          css={entityImageStyle}
        />
        <Text
          variant='paragraphXSmall'
          weight='regular'
          color={colors.NEUTRAL_0}
          style={`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;`}
        >
          {entity?.name || entity?.name_full}
        </Text>
      </div>
    </div>
  )
}

export default EntityDisplay
